import '.dh{outline:none;}.ssr-plugin'
import '.dx{padding:0px;}.ssr-plugin'
import '.di{cursor:pointer;}.ssr-plugin'
import '.o{display:flex;}.ssr-plugin'
import '.v{align-items:center;}.ssr-plugin'
import '.bb{justify-content:center;}.ssr-plugin'
import '.f1{transition:all .2s ease-out;}.ssr-plugin'
import '.f6{scale:1;}.ssr-plugin'
import { styled, Style } from 'inlines'
import { transparentColor } from '../utils/transparentcolor.js'
import { colors } from '../utils/colors.js'

type IconButtonProps = {
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void
  icon: React.ReactNode
  variant?: 'fill' | 'ghost'
  size?: 'small' | 'large'
  style?: Style
  id?: string
  ariaLabel?: string
}

export const IconButton = ({
  onClick,
  icon,
  variant = 'fill',
  size = 'small',
  style,
  id,
  ariaLabel,
}: IconButtonProps) => {
  const dimension = size === 'large' ? 50 : 32
  return (
    <styled.button className="dh dx di o v bb f1 f6"
      onClick={onClick}
      id={id}
      aria-label={ariaLabel}
      style={
        {
          background:
            variant === 'ghost'
              ? 'transparent'
              : transparentColor(colors.white, 0.25),
          border:
            variant === 'fill'
              ? `solid 1px ${colors.border}`
              : 'solid 1px transparent',
          backdropFilter: variant === 'fill' ? 'blur(8px)' : 'none',
          WebkitBackdropFilter: variant === 'fill' ? 'blur(8px)' : 'none',
          borderRadius: dimension,
          width: dimension,
          height: dimension,
          '&:hover': {
            scale: 0.92,
            border: `solid 1px ${colors.border}`,
            background:
              variant === 'fill'
                ? `${transparentColor(colors.white, 0.25)}`
                : `${transparentColor(colors.white, 0.2)}`,
          },
          "html[dir='rtl'] & svg": {
            transform: 'scaleX(-1)',
          },
          ...style,
        } as Style
      }
    >
      {icon}
    </styled.button>
  )
}
